document.addEventListener('DOMContentLoaded', function() {
    const variantSelect = document.querySelector('select[name="id"], input[name="id"][type="radio"]');
    const metafieldElement = document.getElementById('variant-data');

    function updateVariantMetafield() {
        const selectedVariantId = variantSelect.value;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedVariantId);

        fetch(url)
            .then(response => response.text())
            .then(responseText => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const newMetafieldElement = html.getElementById('variant-data');
              if(!document.getElementById('variant-metafield'))return;
                if (newMetafieldElement) {
                    metafieldElement.innerText = newMetafieldElement.innerText;
                    document.getElementById('variant-metafield').style.display = 'block';
                } else {
                    document.getElementById('variant-metafield').style.display = 'none';
                }
            });
    }

    if (variantSelect) {
        variantSelect.addEventListener('change', updateVariantMetafield);
        // Trigger update on page load for the initially selected variant
        updateVariantMetafield();
    }
});
